module.exports = __webpack_public_path__ + "img/honey_oak_961m_list.6fb94fb9.jpg";